import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import PrimaryButton from '~src/shared/buttons/basicButtons/PrimaryButton.sc';

import { Header, SelectedCount, ClearBtn, Container, SaveContainer } from './ddHeaderFooterSaveContent.sc';

interface Props {
  children?: ReactNode
  width?: string;
  selectionInfo: string;
  isDisplayClear: boolean;
  onClickClear(): void;
  onClickSave(): void;
}

const DdHeaderFooterSaveContent: FC<Props> = ({
  children,
  isDisplayClear,
  onClickClear,
  onClickSave,
  selectionInfo,
  width = '220px'
}) => {
  const [t] = useTranslation();
  return (
    <Container $width={(width)!}>
      <Header>
        <SelectedCount>{selectionInfo}</SelectedCount>
        {isDisplayClear && (
          <ClearBtn className="reset-btn" onClick={onClickClear}>
            {t('x.multiselector.clear_button')}
          </ClearBtn>
        )}
      </Header>
      {children}
      <SaveContainer>
        <PrimaryButton onClick={onClickSave} type="button" $buttonSize="mediumWide">
          {t('x.multiselector.save_button')}
        </PrimaryButton>
      </SaveContainer>
    </Container>
  );
};

export default DdHeaderFooterSaveContent;
